class Item {
  rowType = 0;
  element = null;
  constructor(element) {
    this.element = element;
    this.rowType = Number(element.dataset.rowType);
  }

  changeType(type) {
    this.rowType = type;
    this.element.dataset.rowType = type;
  }
}

class Row {
  capacity = 0;
  items = [];
  constructor(capacity) {
    this.capacity = Number(capacity);
    this.items = [];
  }

  addItem(item) {
    if (this.isFull()) {
      throw new Error(`Row is full`);
    }
    this.items.push(item);
  }

  build() {
    const matches = {
      1: `for-one`,
      2: `for-two`,
      3: `for-three`,
    }
    const newElement = document.createElement('div');
    newElement.classList.add('row');
    
    const capacityClass = matches[this.capacity];
    if (!capacityClass) {
      console.warn(`No class mapping found for capacity: ${this.capacity}`);
      newElement.classList.add('for-two');
    } else {
      newElement.classList.add(capacityClass);
    }

    this.items.forEach((item) => {
      const clonedItem = item.element.cloneNode(true);
      newElement.appendChild(clonedItem);
    });

    return newElement;
  }

  /**
   * Call this method once there's now way to fit any more items in the grid
   * This method will reduce the capacity of the row to fit the items
   */
  adjustToFit() {
    if (this.isSpecial())
      this.capacity = this.items.length;
  }

  getItems() {
    return this.items;
  }

  isSpecial() {
    return this.capacity !== 4;
  }

  /**
   * Be warned, this action is destructive and will change the capacity of the row
   * and all the items in it
   */
  changeType(type) {
    this.capacity = type;
    this.items.forEach((item) => {
      item.changeType(type);
    });
  }

  isFull() {
    return this.items.length === this.capacity;
  }

  isEmpty() {
    return this.items.length === 0;
  }

  fillPercentage() {
    return this.items.length / this.capacity;
  }

  fillUpRow(row) {
    while (!row.isFull()) {
      const item = this.items.pop();
      item.changeType(row.capacity);
      row.addItem(item);
    }
  }
}

class Grid {
  static instanceCount = 0;

  hasMoreProducts = true;
  currentPage = 1;
  isLoadingNextPage = false
  parent = null;
  items = [];
  rows = [];

  constructor(parent) {
    Grid.instanceCount++;

    this.parent = parent.querySelector(".mixed-feed");
    if (!this.parent) {
      this.parent = document.createElement("div");
      this.parent.classList.add("mixed-feed");
      parent.appendChild(this.parent);
    }
    this.items = [...parent.querySelectorAll(`[data-row-type]`)].map((el) => new Item(el));
    this.rows = [];

    document.body.onscroll = async () => {
      //const bottom_distance = parent.getBoundingClientRect().bottom
      //// Magic number ahead
      //const should_load_next = bottom_distance <= 1000
      //if (!this.isLoadingNextPage && should_load_next) {
      //  this.isLoadingNextPage = true;
      //  try {
      //    await this.loadNextPage()
      //  } catch (e) {
      //    console.error(e)
      //  } finally {
      //    this.isLoadingNextPage = false
      //  }
      //}

      const bottom_distance = parent.getBoundingClientRect().bottom;
      const should_load_next = bottom_distance <= 1000;
      const loader = document.getElementById('infinite-scroll-loader');

      // Evita volver a mostrar el loader si ya no hay más productos
      if (!this.hasMoreProducts) {
        if (loader) loader.style.display = 'none';
        return;
      }

      if (!this.isLoadingNextPage && should_load_next) {
        this.isLoadingNextPage = true;
        if (loader) loader.style.display = 'flex'; //mostrar spinner
        try {
          await this.loadNextPage();
        } catch (e) {
          console.error(e);
        } finally {
          this.isLoadingNextPage = false;
          if (loader) loader.style.display = 'none'; //ocultar spinner
        }
      }

    }
  }

  async getNextProductPage() {
    const params = new URLSearchParams(window.location.search)
    params.set('page', this.currentPage + 1)
    const res = await fetch(`?${params.toString()}`)
    const doc = new DOMParser().parseFromString(await res.text(), "text/html")
    return [...doc.querySelectorAll('#product-grid > .grid__item[data-row-type]')]
  }

  async loadNextPage() {

    if (!this.hasMoreProducts) return;

    const nextItems = await this.getNextProductPage();


    // Si no hay más productos, marcamos el final
    if (!nextItems.length) {
      this.hasMoreProducts = false;
      return;
    }


    this.parent.parentElement.append(...nextItems);
    this.items = [...this.items, ...nextItems.map((el) => new Item(el))];
    this.build();
    this.currentPage++;
    // ajustando disponibilidad de tallas en las card de colecciones
    if (typeof adjustVariantAvailabilityOnProductCards === "function") {
      adjustVariantAvailabilityOnProductCards();
    } 
   }

  naiveFitting() {
    // Force start from scratch
    this.parent.innerHTML = "";
    this.rows = [];
    this.items.forEach((item) => {
      const row = this.getRow(item.rowType);
      row.addItem(item);
    });
  }

  build() {
    // First step: Naive fitting
    this.naiveFitting();

    // Fill the special rows that are not full yet
    this.fillSpecialRowsWhenPossible();

    // Once there are no more items to place, we need to adjust the rows to fit
    this.notFullRows().forEach((row) => {
      row.adjustToFit();
    });
    // Last step: Build the rows
    this.rows.forEach((row) => {
      this.parent.appendChild(row.build());
    });

    // Extensions
    // plus-icon
    this.parent.parentElement.querySelectorAll('.plus-icon').forEach((el) => {
      el.onclick = (event) => {
        event.stopPropagation();
        document.querySelectorAll(".card-wrapper.plus-clicked")
          .forEach(e => e.classList.remove("plus-clicked"))
        el.closest(".card-wrapper").classList.add('plus-clicked');
      }
    });
    // Load quick add pickers
    setTimeout(() => {
      if (typeof variantPicker === "function") {
        variantPicker();
      }
      if (typeof triggerQuickAdd === "function") {
        triggerQuickAdd();
      }
      if (typeof gridUpdates === "function") {
        gridUpdates();
      }
    }, 1000);

    return this;
  }

  /**
   * Be sure to call this method ONLY when the grid is not already setup
   * @param {*} el The element to setup the grid
   */
  static setup(el) {
    el ??= document.querySelector('#product-grid');
    return new Grid(el).build();
  }
  notFullRows() {
    return this.rows.filter((r) => !r.isFull());
  }

  getRow(type) {
    const row = this.notFullRows().find((r) => r.capacity === type);
    if (row) {
      return row;
    }
    const newRow = new Row(type);
    this.rows.push(newRow);
    return newRow;
  }

  /**
   * This function finds the consecutive special rows and pushes them downwards
   * so they are not together
   */
  distributeSpecialRowsDownwards() {
    // Loop until no special rows have a special row above them
    let mustLoop = true;
    let loops = 0;
    let lastRow = 0;
    while (mustLoop && loops < 100) {
      loops++;
      mustLoop = false;
      for (let i = lastRow; i < this.rows.length; i++) {
        const row = this.rows[i];
        const rowAbove = this.rows[i - 1];
        if (row.isSpecial() && (rowAbove.isSpecial() ?? true)) {
          console.log("Moving row downwards", i, "to", i + 1)
          this.moveRow(i, i + 1);
          mustLoop = true;
        }
      }
    }
  }

  /**
   * This function finds the consecutive special rows and pushes them upwards
   * so they are not together
  */
  distributeSpecialRowsUpwards() {
    // Loop until no special rows have a special row below them
    let mustLoop = true;
    let loops = 0;
    let lastRow = this.rows.length - 1;
    while (mustLoop && loops < 100) {
      loops++;
      mustLoop = false;
      for (let i = lastRow; i > 0; i--) {
        const row = this.rows[i];
        const rowBelow = this.rows[i + 1];
        if (row.isSpecial() && (rowBelow?.isSpecial() ?? true)) {
          this.moveRow(i, i - 1);
          mustLoop = true;
        }
      }
    }
  }

  resolveMoreSpecialThanNormalRows() {
    let specialRowsCount = this.rows.filter((r) => r.isSpecial()).length;
    let normalRowsCount = this.rows.filter((r) => !r.isSpecial()).length;
    let mustRecreateRows = false;
    while (specialRowsCount > normalRowsCount) {
      console.log(`Special rows: ${specialRowsCount}, Normal rows: ${normalRowsCount}`);
      mustRecreateRows = true;
      // If there are more special rows than normal rows, we'll need to mark some items as normal
      // and recreate the rows

      // The priority is: Special rows that are not full, then special rows that are full,
      // and special rows with the most capacity

      // Find the special rows that are not full
      const notFullSpecialRows = this.rows.filter((r) => r.isSpecial() && !r.isFull());
      if (notFullSpecialRows.length > 0) {
        // If there are special rows that are not full, we'll sort them by the fill percentage
        // and mark the first one as normal
        notFullSpecialRows.sort((a, b) => b.fillPercentage() - a.fillPercentage());
        notFullSpecialRows[0].changeType(4);
        specialRowsCount--;
        normalRowsCount++;
      } else {
        // If there are no special rows that are not full, we'll sort them by the capacity
        // and mark the first one as normal
        const fullSpecialRows = this.rows.filter((r) => r.isSpecial());
        fullSpecialRows.sort((a, b) => b.capacity - a.capacity);
        fullSpecialRows[0].changeType(4);
        specialRowsCount--;
        normalRowsCount++;
      }
    }

    if (mustRecreateRows) {
      this.naiveFitting();
    }
  }

  fillSpecialRowsWhenPossible() {
    let mustLoop = true;
    let loops = 0;
    while (mustLoop || loops < 100) {
      loops++;
      // Find the special rows that are not full
      const notFullSpecialRows = this.rows.filter((r) => r.isSpecial() && !r.isFull());

      // If there are no special rows that are not full, we are done
      if (notFullSpecialRows.length === 0) {
        return;
      }

      // Sort the special rows by the capacity (ascending) and the fill percentage (descending)
      notFullSpecialRows.sort((a, b) => {
        if (a.capacity === b.capacity) {
          return b.fillPercentage() - a.fillPercentage();
        }
        return a.capacity - b.capacity;
      });

      // Get the first special row
      const fillCandidate = notFullSpecialRows[0];

      // Find the items that can be placed in the special row (1/2 + 1/3)
      if (fillCandidate.capacity === 2) {
        // For this case we can fill with a 1/3
        const rows = this.rows.filter((r) => r.capacity === 3 && r.items.length === 1);
        if (rows.length > 0) {
          // If there are rows that can be filled with a 1/3, we'll fill the special row with it
          const row = rows[0];
          row.fillUpRow(fillCandidate);

          // Remove the now empty row
          this.rows = this.rows.filter((r) => r !== row);
          continue;
        }
      }

      // If we reach this point, it means we couldn't fill the special row with a smaller item
      mustLoop = false;
    }
  }

  moveRow(from, to) {
    const row = this.rows[from];
    this.rows.splice(from, 1);
    this.rows.splice(to, 0, row);
  }

  getRows() {
    return this.rows;
  }

  endsWithSpecialRow() {
    return this.rows[this.rows.length - 1].isSpecial();
  }

  startsWithSpecialRow() {
    return this.rows[0].isSpecial();
  }
}

document.addEventListener('DOMContentLoaded', function () {
  window.mixedFeedGrid = Grid.setup();

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(mutation => {
      if (mutation.removedNodes && 
          [...mutation.removedNodes].some(node => 
            node.classList?.contains('loading') && 
            node.classList.contains('collection'))) {
        window.mixedFeedGrid = Grid.setup();
      }
    });
  });

  observer.observe(document.getElementById('ProductGridContainer'), { 
    childList: true 
  });
});